import { Navigate, Route, Routes } from "react-router-dom";
import {Welcome, Categories, ConnectEmail, ComingSoon, Syncing} from '../pages/Onboarding';
import {OAuthCallback} from '../pages/OAuthCallback';

const AuthRoutes = () => {
  return (
    <Routes>

        {/* OAuth callback — handles redirect from Google */}
        <Route path="/auth" element={<OAuthCallback />} />

        {/* Onboarding */}
        <Route
            path="/onboarding"
            element={<Welcome />}
        />
        <Route
            path="/onboarding/categories"
            element={<Categories />}
        />
        <Route
            path="/onboarding/connect-email"
            element={<ConnectEmail />}
        />
        <Route
            path="/onboarding/coming-soon"
            element={<ComingSoon />}
        />
        <Route
            path="/onboarding/syncing"
            element={<Syncing />}
        />

      {/* Default redirect */}
      <Route path="*" element={<Navigate to="/onboarding" replace />} />
    </Routes>
  );
};

export default AuthRoutes;
